module.exports = __webpack_public_path__ + "98271459a68eef1b5b641ceb2fdf9e08.svg";